import referrer from 'js/lib/referrer';
import { useLocation } from 'js/lib/useRouter';

import { ONBOARDING_BASE_URL } from 'bundles/onboarding-common/constants';

/**
 * Hook that uses the referrer and location data to determine if the onboarding is from an unregistered onboarding signup flow.
 *
 * @returns {boolean} - true if the onboarding is from an unregistered onboarding signup flow, false otherwise
 */
const useIsFromUnregisteredOnboarding = () => {
  const location = useLocation();

  return {
    isFromUnregisteredOnboardingSignupFlow:
      (location.query?.registrationReferrer === 'uvOnboarding' ||
        referrer.get()?.includes(`${ONBOARDING_BASE_URL}/signup`)) ??
      false,
  };
};

export default useIsFromUnregisteredOnboarding;
